export default __webpack_public_path__ + "static/media/bangladesh-flag.ff7a7bb7.svg";